import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import ExternalLink from '../ExternalLink';
import styles from './Footer.module.css';

interface FamilySite {
  name: string;
  url: string;
}

const familySites: FamilySite[] = [
  { name: '한국승강기안전공단', url: 'https://home.koelsa.or.kr/' },
  { name: '승강기민원24', url: 'https://minwon.koelsa.or.kr/' },
  { name: '승강기 교육센터', url: 'https://edu.koelsa.or.kr/' },
  { name: '승강기안전기술원', url: 'https://esti.koelsa.or.kr/' },
];

const Footer: React.FC = () => {
  const [familySiteOpen, setFamilySiteOpen] = useState(false);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  const toggleFamilySite = () => {
    setFamilySiteOpen(!familySiteOpen);
  };

  return (
    <footer className={styles.mainFooter}>
      <div className={styles.footerTop}>
        <div className={styles.container}>
          <nav className={styles.footerNav}>
            <Link to="/policy/private">개인정보처리방침</Link>
            <Link to="/policy/email">이메일무단수집거부</Link>
          </nav>
        </div>
      </div>

      <div className={styles.footerBottom}>
        <div className={styles.container}>
          <div className={styles.footerContent}>
            <div className={styles.footerLogo}>
              <img src="/images/logo.png" alt="한국승강기안전기술관리원" />
            </div>

            <div className={styles.footerInfo}>
              <p>
                <strong>고유 번호</strong> 628-82-00667{' '}



                  <strong>이사장</strong> 채성준

              </p>
              <p>
                <strong>Address</strong> (우) 13943 경기도 안양시 동안구 흥안대로 500 (서현빌딩) 6층 602호
              </p>
              <p>
                <strong>Email</strong>{' '}
                <span data-email="kesti2026" data-domain="daum.net"></span>
              </p>
            </div>

            <div className={styles.footerFamilySite}>
              <button
                className={`${styles.familySiteToggle} ${familySiteOpen ? styles.active : ''}`}
                onClick={toggleFamilySite}
                aria-expanded={familySiteOpen}
                aria-label="관련사이트"
              >
                관련사이트
                <span className={styles.toggleIcon}>{familySiteOpen ? '▲' : '▼'}</span>
              </button>

              {familySiteOpen && (
                <ul className={styles.familySiteList}>
                  {familySites.map((site, index) => (
                    <li key={index}>
                      <ExternalLink href={site.url}>
                        {site.name}
                      </ExternalLink>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          </div>

          <div className={styles.footerCopyright}>
            <p>COPYRIGHT (c) KESTI ALL RIGHTS RESERVED</p>
          </div>

          <button className={styles.scrollTop} onClick={scrollToTop} aria-label="맨 위로">
            ↑<br />TOP
          </button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
